import { render, staticRenderFns } from "./NbPageFooterText.vue?vue&type=template&id=3d8b8e92&scoped=true&"
import script from "./NbPageFooterText.vue?vue&type=script&lang=js&"
export * from "./NbPageFooterText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8b8e92",
  null
  
)

export default component.exports